import { InjectionToken } from '@angular/core';

/**
 * Supplies the currently authenticated user's permission codes to the shared
 * {@link PermissionsService}.
 *   {
 *     provide: PERMISSIONS_SOURCE,
 *     useFactory: (userService: UserService) =>
 *       () => userService.currentAdmin()?.permissions ?? [],
 *     deps: [UserService],
 *   }
 */
export type PermissionsSource = () =>
  | readonly string[]
  | string[]
  | null
  | undefined;

export const PERMISSIONS_SOURCE = new InjectionToken<PermissionsSource>(
  'PERMISSIONS_SOURCE'
);
